import graphql__a17ceb128d440ccd0f65 from "./__generated__/EventModal_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";

import Modal from "../Modals/Modal";
import TitleBarWithAction from "../ParticipativeModule/TitleBarWithAction";
import { isUnauthorized } from "../Utils/authorizations";
import EventDetails from "./EventDetails";
import SubscribeToEventButton from "./SubscribeToEventButton";

const EventModal = props => {
  const participativeModule = useFragment(
    EventModal_participativeModule,
    props.participativeModule
  );

  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;

  const isSubscriptionAuthorized = !isUnauthorized(contributionsSubmissionAuthorized);

  const titleAction = isSubscriptionAuthorized && (
    <SubscribeToEventButton
      participativeModule={participativeModule}
      className="btn btn-primary btn-block-md box-shadow-lg btn-expand-height padding-sm"
    />
  );

  return (
    <Modal isOpen={true} shouldCloseOnOverlayClick={true} className="contribution-modal">
      <div className="container event-container modal-buttons-container">
        <TitleBarWithAction
          resource={participativeModule}
          action={titleAction}
          sticky={false}
          className="margin-bottom-xs"
        />

        <EventDetails participativeModule={participativeModule} />
      </div>
    </Modal>
  );
};

const EventModal_participativeModule = graphql__a17ceb128d440ccd0f65;

export default EventModal;
